// /client/src/components/RecentActivity.js
import React, { useState, useEffect, useCallback } from 'react';

const RecentActivity = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchRecentActivities = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      const response = await fetch('/api/activity/recent?limit=5', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setActivities(data.activities || []);
        }
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Failed to fetch activities');
      }
    } catch (err) {
      setError('Failed to load activities');
      console.error('Error fetching recent activities:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRecentActivities();
  }, [fetchRecentActivities]);

  // Format date for display
  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      timeZone: 'America/Los_Angeles',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  // Get category badge class
  const getCategoryColor = (category) => {
    const categoryColors = {
      contact: 'is-info',
      pod: 'is-primary',
      product: 'is-link',
      program: 'is-success',
      message: 'is-warning',
      auth: 'is-danger',
      system: 'is-dark',
      campaign: 'is-primary'
    };
    return categoryColors[category] || 'is-light';
  };

  if (loading) {
    return (
      <div className="box">
        <h2 className="subtitle is-5 mb-3">Recent Activity</h2>
        <div className="has-text-centered py-4">
          <p className="is-size-7">Loading activities...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="box">
        <h2 className="subtitle is-5 mb-3">Recent Activity</h2>
        <div className="notification is-danger is-light is-size-7">
          {error}
          <button 
            className="button is-small is-light mt-2" 
            onClick={fetchRecentActivities}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="box boxHeight">
        <div className='mb-3 p-0 is-flex is-justify-content-space-between is-align-items-center' style={{ borderBottom: '1px solid #f0f0f0' }}>
            <div className='mb-3 p-0'>
                <h2 className="subtitle is-5 m-0 p-0 is-bold">Recent Activity</h2>
            </div>
            <div className='mb-3 p-0'>
                <a href="/activity" className='m-0 p-0 psmall colorBlue'>View more</a>
            </div>
        </div>
      
        {activities.length === 0 ? (
            <p className="is-size-7 has-text-grey">No recent activity</p>
        ) : (
        <div className="activity-list">
          {activities.map((activity) => (
            <div 
              key={activity._id} 
              className="activity-item my-3 pb-3"
              style={{ borderBottom: '1px solid #f0f0f0' }}
            >
              <div className="is-flex is-justify-content-space-between is-align-items-start mb-1">
                <span className="is-size-7 has-text-grey is-bold">
                  {formatDateTime(activity.createdAt)}
                </span>
                {/* <span className={`tag is-small ${getCategoryColor(activity.category)}`}>
                  {activity.category ? activity.category.charAt(0).toUpperCase() + activity.category.slice(1) : 'N/A'}
                </span> */}
              
              <p className="is-size-7 my-1">
                <code className="is-size-7">{activity.action}</code>
              </p>
              </div>
              <p className="is-size-7 has-text-grey-dark my-1" style={{ lineHeight: '1.3' }}>
                {activity.description}
              </p>
              <p className="is-size-7 has-text-grey my-1">
                by {activity.performedByName || 'System'}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentActivity;